import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于韩国漫画网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                <h4 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </h4>
                <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}